import React from 'react';
import type ServicedeskQueuesIssueViewType from '@atlassian/jira-spa-apps-servicedesk-queues-issue-view/src/index.tsx';
import { LazyPage } from '@atlassian/jira-spa/src/view/lazy-page/index.tsx';
import { lazyForPaint } from '@atlassian/react-loosely-lazy';
import type { RouteContext } from '@atlassian/react-resource-router';

// eslint-disable-next-line jira/deprecations/no-rll-client-async-experiences
export const LazyServicedeskQueuesIssueView = lazyForPaint<typeof ServicedeskQueuesIssueViewType>(
	() =>
		import(
			/* webpackChunkName: "async-servicedesk-queues-issue-view", jiraSpaEntry: "async-servicedesk-queues-issue-view" */ '@atlassian/jira-spa-apps-servicedesk-queues-issue-view'
		),
	{
		ssr: false,
	},
);
type Props = RouteContext;

/**
 * Constructs a URL path for navigating to a specific issue view within a service desk queue, incorporating optional parameters for issue identification and view customization.
 */

const AsyncServicedeskQueuesIssueView = ({ match }: Props): React.JSX.Element => {
	const issueKey = `/${(match.params && match.params.issueKey) || ''}`;
	const queueId = `/${(match.params && match.params.queueId) || ''}`;
	const oldIssueView = `/${(match.query && match.query.oldIssueView) || ''}`;
	return (
		<LazyPage
			Page={LazyServicedeskQueuesIssueView}
			pageId={`spa-apps/servicedesk/queues/issue${queueId}${issueKey}${oldIssueView}`}
			shouldShowSpinner
		/>
	);
};

export default AsyncServicedeskQueuesIssueView;
